import React, { Fragment, useState } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { Btn } from '../../../AbstractElements';
import { useNavigate } from 'react-router-dom';
import { firebase_app } from '../../../Config/Config';
import man from '../../../assets/images/dashboard/1.png';
import Logo from '../../../assets/images/logo/maxpark-logo-white@2x-50.png';

const LoginTab = ({ selected }) => {
    const [email, setEmail] = useState(localStorage.getItem('loginEmail') || '');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(true);
    const [loading, setLoading] = useState(false);
    const [togglePassword, setTogglePassword] = useState(false);

    const [errorEmail, setErrorEmail] = useState(false);
    const [errorPassword, setErrorPassword] = useState(false);
    const [errorForm, setErrorForm] = useState(false);

    const [errorEmailMsg, setErrorEmailMsg] = useState('');
    const [errorPasswordMsg, setErrorPasswordMsg] = useState('');
    const [errorFormMsg, setErrorFormMsg] = useState('');

    const navigate = useNavigate();

    const validateForm = () => {
        let isValid = true;

        setErrorEmail(false);
        setErrorPassword(false);
        setErrorForm(false);

        if (!email.trim()) {
            setErrorEmail(true);
            setErrorEmailMsg('Veuillez entrer une adresse courriel');
            isValid = false;
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email.trim())) {
            setErrorEmail(true);
            setErrorEmailMsg('Courriel invalide ex: jon@email.com');
            isValid = false;
        }

        if (!password) {
            setErrorPassword(true);
            setErrorPasswordMsg('Veuillez entrer un mot de passe');
            isValid = false;
        }

        return isValid;
    };

    const getFirebaseErrorMessage = (error) => {
        switch (error?.code) {
            case 'auth/user-not-found':
            case 'auth/wrong-password':
            case 'auth/invalid-credential':
            case 'auth/invalid-login-credentials':
                return 'Erreur, le courriel ou le mot de passe est invalide.';
            case 'auth/api-key-not-valid.-please-pass-a-valid-api-key.':
            case 'auth/api-key-not-valid':
                return 'Erreur de configuration Firebase : clé API invalide.';
            case 'auth/too-many-requests':
                return 'Trop de tentatives. Veuillez réessayer plus tard ou réinitialiser le mot de passe.';
            case 'auth/network-request-failed':
                return 'Erreur réseau. Veuillez vérifier votre connexion et réessayer.';
            default:
                return `Erreur d'authentification${error?.code ? ` (${error.code})` : ''}.`;
        }
    };

    const loginAuth = async (event) => {
        event.preventDefault();

        if (loading) {
            return;
        }

        if (!validateForm()) {
            return;
        }

        setLoading(true);
        setErrorForm(false);

        try {
            await firebase_app
                .auth()
                .signInWithEmailAndPassword(email.trim(), password);

            localStorage.setItem('profileURL', man);
            localStorage.setItem('Name', email.trim());

            if (rememberMe) {
                localStorage.setItem('loginEmail', email.trim());
            } else {
                localStorage.removeItem('loginEmail');
            }

            // IMPORTANT:
            // Use an absolute route. A relative redirect from /auth creates /auth/dashboard on production.
            navigate('/dashboard', { replace: true });
        } catch (error) {
            console.error('[Login Error]', error?.code, error?.message);
            setErrorForm(true);
            setErrorFormMsg(getFirebaseErrorMessage(error));
            setLoading(false);
        }
    };

    return (
        <Fragment>
            <div className="login-card">
                <Form className="theme-form" onSubmit={loginAuth}>
                    <img className="m-b-40" src={Logo} alt="Max Park" />

                    <h4 className="f-color-light-text">Authentification</h4>

                    <span className={`error-form d-block m-b-10 ${!errorForm ? 'hidden' : ''}`}>
                        {errorFormMsg}
                    </span>

                    <p className="f-color-light-text">Veuillez entrer vos informations</p>

                    <FormGroup>
                        <Label className="col-form-label">Courriel</Label>
                        <Input
                            className="form-control"
                            type="email"
                            name="email"
                            required
                            value={email}
                            autoComplete="email"
                            onChange={(event) => {
                                setEmail(event.target.value);
                                setErrorEmail(false);
                                setErrorForm(false);
                            }}
                            onBlur={validateForm}
                        />
                        <span className={`error-form ${!errorEmail ? 'hidden' : ''}`}>
                            {errorEmailMsg}
                        </span>
                    </FormGroup>

                    <FormGroup className="position-relative">
                        <Label className="col-form-label">Mot de passe</Label>
                        <Input
                            className="form-control"
                            type={togglePassword ? 'text' : 'password'}
                            name="password"
                            required
                            value={password}
                            autoComplete="current-password"
                            onChange={(event) => {
                                setPassword(event.target.value);
                                setErrorPassword(false);
                                setErrorForm(false);
                            }}
                            onBlur={validateForm}
                        />
                        <span className={`error-form ${!errorPassword ? 'hidden' : ''}`}>
                            {errorPasswordMsg}
                        </span>

                        <div
                            className="show-hide"
                            onClick={() => setTogglePassword(!togglePassword)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    setTogglePassword(!togglePassword);
                                }
                            }}
                        >
                            <span className={togglePassword ? '' : 'show'} />
                        </div>
                    </FormGroup>

                    <div className="form-group mb-0">
                        <div className="checkbox ms-3">
                            <Input
                                id="checkbox1"
                                type="checkbox"
                                checked={rememberMe}
                                onChange={(event) => setRememberMe(event.target.checked)}
                            />
                            <Label className="text-muted" htmlFor="checkbox1">Mémoriser</Label>
                        </div>

                        <a className="link" href="#javascript">Mot de passe oublié</a>
                    </div>

                    <Btn
                        attrBtn={{
                            color: 'primary',
                            className: 'btn-block m-t-20 float-right',
                            disabled: loading,
                            type: 'submit',
                        }}
                    >
                        {loading ? 'ENVOI..' : 'Authentifier'}
                    </Btn>
                </Form>
            </div>
        </Fragment>
    );
};

export default LoginTab;
